import React, { useState } from "react";

import {
  Button,
  Container,
  Grid,
  TextField,
  Typography
} from "@material-ui/core";

import { sendEmail } from "./App.service";

import Header from "./Header";

import "./App.css";
import Footer from "./Footer";

const App: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isSent, setIsSent] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleChange = (event: any) => {
    setEmail(event.target.value);
  };

  const isEmailValid = () => {
    return email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
  };

  const onSuccess = () => {
    setIsSending(false);
    setIsSent(true);
  };

  const onError = (error: any) => {
    setIsSending(false);
    console.error("Error sending email", error);
  };

  const onKeepMeUpdated = async () => {
    setIsSending(true);

    try {
      await sendEmail(email);
      onSuccess();
    } catch(e) {
      onError(e);
    }
  };
  return (
    <div className="App">
      <Header />
      <Container className="App-body">
        <Typography variant="h1">COMING SOON</Typography>
        <Typography variant="body1">
          Please check back in soon for awesome content
        </Typography>
        <br />
        <br />
        <br />
        <br />
        <Grid
          container
          spacing={2}
          direction="row"
          justify="center"
          alignItems="stretch"
          style={{ height: 73 }}
        >
          {!isSent ? (
            <React.Fragment>
              <Grid item xs="auto">
                <TextField
                  label="Email Address"
                  variant="outlined"
                  margin="none"
                  value={email}
                  onChange={handleChange}
                  style={{ width: 300 }}
                  disabled={isSending}
                />
              </Grid>
              <Grid item xs="auto">
                <Button
                  className="App-contact-button"
                  size="large"
                  variant="outlined"
                  style={{ height: "100%" }}
                  onClick={onKeepMeUpdated}
                  disabled={!isEmailValid() || isSending}
                >
                  Keep me Updated!
                </Button>
              </Grid>
            </React.Fragment>
          ) : (
            <Grid item xs="auto">
              <Button
                className="App-contact-button"
                size="large"
                variant="outlined"
                style={{ width: 200, height: "100%" }}
              >
                Thanks!
              </Button>
            </Grid>
          )}
        </Grid>
        <Footer />
      </Container>
    </div>
  );
};

export default App;
